import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { postAPI } from "../backend/commons";

export const uploadCostFile = async (file, isApproved) => {
    const fileFormData = new FormData();
    fileFormData.append('cost-file', file);
    fileFormData.append('is-approved', isApproved);

    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
        window.location.href = "/";
    }
    let apiUrl =
        localDatabaseUrls.baseURL +
        localDatabaseUrls.serviceURL.costUpload

    return postAPI(apiUrl,fileFormData,tokenInfo);
    // await fetch(apiUrl, {
    //     method: "POST",
    //      headers: localDatabaseUrls.temp_headers,
    //     // headers: {
    //     //     Authorization: 'Bearer ' + tokenInfo.id_token,
    //     //     Principal: tokenInfo.access_token,
    //     // },
    //     body: fileFormData
    // });
}
